import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { connect } from "react-redux";
import { getDashboardInternshipCount } from "../../../actions/dashboardActions";
import NoDataFound from "./noDataFound_Chart";
import ChartLoading from "./chartLoading";
import { useTranslation } from "react-i18next";
import "./style.css";

const options = {
	colors: ["#7CD4FD", "#0086C9"],
	chartArea: { left: 0, top: 20, width: "100%", height: "70%" },
	fontSize: 14,
	legend: {
		alignment: "center",
		position: "bottom",
	},
	annotations: {
		textStyle: {
			fontName: "inherit",
			fontSize: 14,
		},
		alwaysOutside: true,
		boxStyle: {
			rx: 10,
			ry: 10,
		},
		datum: {
			stem: {
				color: "transparent",
				length: 5,
			},
		},
	},
	vAxis: {
		gridlines: {
			color: "transparent",
			count: 0,
		},
		baselineColor: "#0086C9",
	},
};

const headerRowDefault = [["Year", `Internship`, `Recruitment`]];
// export const data1 = [
// 	[
// 		"Year",
// 		"Internship (46)",
// 		{ role: "annotation" },
// 		"Recruitment (42)",
// 		{ role: "annotation" },
// 	],
// 	["2014", "4", "4", "6", "6"],
// 	["2015", "7", "7", "6", "6"],
// 	["2016", "12", "12", "10", "10"],
// 	["2017", "23", "23", "20", "20"],
// ];

const InternshipHistory = ({
	isLoading,
	internshipCountStatus,
	getDashboardInternshipCount,
	companyId,
}) => {
	const [data, setData] = useState([]);
	const { t } = useTranslation();

	useEffect(() => {
		if (companyId) getDashboardInternshipCount(companyId);
	}, [companyId]);

	useEffect(() => {
		let _data = [];
		let totalInternshipCount = 0;
		let totalRecruitmentCount = 0;

		if (internshipCountStatus) {
			const currentYear = new Date().getFullYear();
			const yearsToShow = [
				(currentYear - 3).toString(),
				(currentYear - 2).toString(),
				(currentYear - 1).toString(),
				currentYear.toString(),
			];

			yearsToShow.forEach((year) => {
				const internshipCount = internshipCountStatus[year].Internship;
				totalInternshipCount = totalInternshipCount + internshipCount;
				const recruitmentCount = internshipCountStatus[year].Recruitment;
				totalRecruitmentCount = totalRecruitmentCount + recruitmentCount;
				_data.push([
					year,
					internshipCount,
					internshipCount.toString(),
					recruitmentCount === 0 ? 1 : recruitmentCount,
					recruitmentCount.toString() === "0"
						? "?"
						: recruitmentCount.toString(),
				]);
			});
		}
		const headerRow = [
			[
				"Year",
				`${t(
					"dashboard_sectionfooter_internshipHistory_internship"
				)} (${totalInternshipCount})`,
				{ role: "annotation" },
				`${t(
					"dashboard_sectionfooter_internshipHistory_recruitment"
				)} (${totalRecruitmentCount})`,
				{ role: "annotation" },
			],
		];

		setData([...headerRow, ..._data]);
	}, [internshipCountStatus]);

	return (
		<div className="stat_container">
			<div className="stat_chart_title">
				{t("dashboard_sectiontitle_internshipHistory")}
			</div>
			{isLoading && <ChartLoading />}
			{!isLoading && internshipCountStatus && (
				<>
					<Chart
						chartType="ColumnChart"
						width="100%"
						height="250px"
						data={data}
						options={options}
					/>
				</>
			)}
			{!isLoading && !internshipCountStatus && <NoDataFound />}
		</div>
	);
};

const mapStateToProps = (state) => ({
	isLoading: state.dashboard.internshipCountStatusLoading,
	internshipCountStatus: state.dashboard.internshipCountStatus,
	companyId: state.firebase.profile.companyId,
});

export default connect(mapStateToProps, { getDashboardInternshipCount })(
	InternshipHistory
);
